import {apiRequest} from '.'

export const resignation = async (token, data)=>{
    try{
        const response = await apiRequest({
            url: '/resignation',
            method: 'POST',
            data: data,
            token
        })

        return response
    }catch(error){
        console.log(error)
    }
}

export const fetchResignations = async (token)=>{
    try{
        const response = await apiRequest({
            url: '/resignation',
            token
        })

        return response
    }catch(error){
        console.log(error)
    }
}

export const updateResignations = async (token, data, id)=>{
    try{
        const response = await apiRequest({
            url: `/resignation/${id}`,
            method: 'PUT',
            data: data,
            token
        })

        return response
    }catch(error){
        console.log(error)
    }
}